export default function reviews(
  state = {
    phoneType: null,
    isPhone: false
  },
  action
) {
  switch (action.type) {
    case 'GOT_PHONE_TYPE':
      return {
        ...state,
        phoneType: action.payload,
        isPhone: !!action.payload
      }

    default:
      return state
  }
}
